export class ApiUrl {
  //BaseUrl: string = "http://localhost/happyfleetccatoi_api/index.php";
  BaseUrl: string = "http://happyfleetccatoi-api.happyfleets.com/index.php";
  //BaseUrl: string = "http://test-api.happyfleets.com/index.php";
}
